export default __webpack_public_path__ + "static/media/temp-up.cc87a3dd.svg";